import { Swiper } from 'swiper';

const speed = 800;

// Drive every carousel from one timer so they stay locked together — independent Swiper
// autoplay instances drift apart. The hero advances every other tick to swipe in unison.
const tickDelay = 3000;

main();

function main() {
    const synced: Swiper[] = [];
    const $containers: HTMLElement[] = [];
    let hero: Swiper | undefined;

    const $sliderContainerOne = document.querySelector<HTMLElement>('#slider-one');
    if ($sliderContainerOne) {
        $containers.push($sliderContainerOne);
        hero = new Swiper($sliderContainerOne, {
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            watchOverflow: true,
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            speed,
        });
    }

    const $sliderContainerTwo = document.querySelector<HTMLElement>('#slider-two');
    if ($sliderContainerTwo) {
        $containers.push($sliderContainerTwo);
        synced.push(new Swiper($sliderContainerTwo, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centerInsufficientSlides: true,
            loop: false,
            grabCursor: true,
            speed,
        }));
    }

    const $sliderContainerThree = document.querySelector<HTMLElement>('#slider-three');
    if ($sliderContainerThree) {
        $containers.push($sliderContainerThree);
        synced.push(new Swiper($sliderContainerThree, {
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            watchOverflow: true,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 60,
            grabCursor: true,
            speed,
        }));
    }

    const advance = (swiper: Swiper) => {
        if (!swiper.params.loop && swiper.isEnd) {
            swiper.slideTo(0);
        } else {
            swiper.slideNext();
        }
    };

    let tick = 0;
    let timer: number | undefined;

    const run = () => {
        if (timer !== undefined) {
            return;
        }
        timer = window.setInterval(() => {
            for (const swiper of synced) {
                advance(swiper);
            }
            if (hero && tick % 2 === 1) {
                advance(hero);
            }
            tick++;
        }, tickDelay);
    };

    const stop = () => {
        if (timer === undefined) {
            return;
        }
        window.clearInterval(timer);
        timer = undefined;
    };

    // Pausing only the hovered carousel would let the others drift, so pause the whole set.
    for (const $container of $containers) {
        $container.addEventListener('mouseenter', stop);
        $container.addEventListener('mouseleave', run);
    }

    run();
}
